import { get } from 'lodash';
import ArchivePayment from '../entities/ArchivePaymentEntity';
import StandingOrder from '../entities/StandingOrderEntity';
import DirectDebit from '../entities/DirectDebitEntity';
import StringConstant from '../constants/StringConstants';

export class ManagePaymentsParser {
  parseDirectDebitArchiveData(archivedDirectDebit) {
    const archivePayment = new ArchivePayment();
    archivePayment.id = archivedDirectDebit.id;
    archivePayment.fromAccountName = archivedDirectDebit.fromAccountName;
    archivePayment.fromAccountId = archivedDirectDebit.fromAccountId;
    archivePayment.fromAccountNumber = archivedDirectDebit.fromAccountNumber;
    archivePayment.toAccountName = archivedDirectDebit.display_name;
    archivePayment.category = StringConstant.DDPayment;
    archivePayment.type = StringConstant.DDText;
    if (archivedDirectDebit.hasOwnProperty('previous_payment')) {
      archivePayment.amount = archivedDirectDebit.previous_payment.amount.value;
      archivePayment.when = archivedDirectDebit.previous_payment.when;
      archivePayment.reference = archivedDirectDebit.previous_payment.reference;
    } else {
      archivePayment.reference = archivedDirectDebit.reference;
      archivePayment.type = StringConstant.singlePayType;
    }
    return archivePayment;
  }

  parseStandingOrderArchiveData(archievedStandingOrder) {
    const archivePayment = new ArchivePayment();
    archivePayment.id = archievedStandingOrder.id;
    archivePayment.fromAccountName = archievedStandingOrder.fromAccountName;
    archivePayment.fromAccountId = archievedStandingOrder.fromAccountId;
    archivePayment.fromAccountNumber = archievedStandingOrder.fromAccountNumber;
    archivePayment.toAccountName = archievedStandingOrder.display_name;
    archivePayment.reference = archievedStandingOrder.reference;
    archivePayment.payType = archievedStandingOrder.payType;
    archivePayment.category = archievedStandingOrder.category;
    archivePayment.accountNumber = archievedStandingOrder.account_number;
    archivePayment.sortCode = archievedStandingOrder.sort_code;
    archivePayment.paymentType = StringConstant.oneOffPayment;
    if (archievedStandingOrder.hasOwnProperty('schedule')) {
      archivePayment.paymentType = StringConstant.standingOrder;
      archivePayment.type = StringConstant.SOText;
      archivePayment.category = StringConstant.SOPayment;
      archivePayment.when = archievedStandingOrder.schedule.next_payment.when;
      archivePayment.amount =
        archievedStandingOrder.schedule.next_payment.amount.value;
    } else if (archievedStandingOrder.hasOwnProperty('single')) {
      archivePayment.when = archievedStandingOrder.single.when;
      archivePayment.amount = archievedStandingOrder.single.amount.value;
      if (archivePayment.payType === StringConstant.payment) {
        archivePayment.type = StringConstant.singlePayType;
      } else {
        archivePayment.type = StringConstant.transfer;
      }
    }
    return archivePayment;
  }

  parseStandingOrderActiveData(activeStandingOrder) {
    const standingOrder = new StandingOrder();
    standingOrder.id = activeStandingOrder.id;
    standingOrder.fromAccountName = activeStandingOrder.fromAccountName;
    standingOrder.fromAccountId = activeStandingOrder.fromAccountId;
    standingOrder.fromAccountNumber = activeStandingOrder.fromAccountNumber;
    standingOrder.toAccountName = activeStandingOrder.display_name;
    standingOrder.reference = get(activeStandingOrder, 'reference', '');
    standingOrder.toAccountId = get(activeStandingOrder, 'account_id', '');
    standingOrder.sortCode = activeStandingOrder.sort_code;
    standingOrder.accountNumber = activeStandingOrder.account_number;
    standingOrder.payType = activeStandingOrder.payType;
    standingOrder.category = StringConstant.SOPayment;
    standingOrder.isInternalPayment = activeStandingOrder.is_internal_payment;
    standingOrder.isSoWrite =
      activeStandingOrder.actions_available['/account/mandates/so/write'];
    if (activeStandingOrder.hasOwnProperty('schedule')) {
      standingOrder.soType = 'SCHEDULE';
      standingOrder.scheduleData = activeStandingOrder.schedule;
      standingOrder.frequency =
        activeStandingOrder.schedule.recurrence.frequency;
      standingOrder.when = activeStandingOrder.schedule.next_payment.when;
      standingOrder.type = StringConstant.SOText;
      standingOrder.amount =
        activeStandingOrder.schedule.next_payment.amount.value;
      standingOrder.currency =
        activeStandingOrder.schedule.next_payment.amount.currency;
      standingOrder.paymentType = StringConstant.standingOrder;
    } else {
      standingOrder.soType = 'SINGLE';
      standingOrder.singleData = activeStandingOrder.single;
      standingOrder.when = activeStandingOrder.single.when;
      standingOrder.amount = activeStandingOrder.single.amount.value;
      standingOrder.currency = activeStandingOrder.single.amount.currency;
      if (standingOrder.payType === StringConstant.payment) {
        standingOrder.type = StringConstant.singlePayType;
      } else {
        standingOrder.type = StringConstant.transfer;
      }
      standingOrder.paymentType = StringConstant.oneOffPayment;
    }
    return standingOrder;
  }

  parseDirectDebitActiveData(activeDirectDebit) {
    const directDebit = new DirectDebit();
    directDebit.id = activeDirectDebit.id;
    directDebit.fromAccountName = activeDirectDebit.fromAccountName;
    directDebit.fromAccountId = activeDirectDebit.fromAccountId;
    directDebit.fromAccountNumber = activeDirectDebit.fromAccountNumber;
    directDebit.toAccountName = activeDirectDebit.display_name;
    // directDebit.reference = activeDirectDebit.reference; this is Originator reference need not to displayed
    directDebit.payType = activeDirectDebit.payType;
    directDebit.category = StringConstant.DDPayment;
    directDebit.type = StringConstant.DirectDebit;
    if (activeDirectDebit.hasOwnProperty('previous_payment')) {
      directDebit.amount = activeDirectDebit.previous_payment.amount.value;
      directDebit.when = activeDirectDebit.previous_payment.when;
      directDebit.reference = activeDirectDebit.previous_payment.reference;
    }
    return directDebit;
  }
}

export default ManagePaymentsParser;
